import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getUserReferringSummaries({ date, interval, endDate = null }) {
    return axiosIns.get(
      '/admin/user_referring_summaries',
      {
        params: snakecaseKeys({
          date,
          interval,
          endDate,
        }),
      },
      { timeout: 8000 },
    )
  },
  getUserReferringDailySummaries({
    date,
    interval,
    userId,
    endDate = null,
  }) {
    return axiosIns.get(
      `/admin/user_referring_summaries/daily_list/${userId}`,
      {
        params: snakecaseKeys({
          date,
          interval,
          userId,
          endDate,
        }),
      },
      { timeout: 8000 },
    )
  },
}
